import React from 'react';
import { Typography, Card, Grid } from '@mui/material';
import { Link } from 'react-router-dom';

import { Colors } from '../utils/Colors';

interface IReportSummaryCardProps {
  title: string;
  value: string;
  grey?: true;
}

export function ReportSummaryCard({
  title,
  value,
  grey
}: IReportSummaryCardProps) {
  return (
    <Link to="/reports" style={{ textDecoration: 'none' }}>
      <Card
        sx={{
          minWidth: '225px',
          maxWidth: '225px',
          minHeight: '225px',
          height: '225px',
          padding: '15px',
          backgroundColor: grey ? Colors.lightGray : Colors.celeste,
          borderRadius: '20px',
          boxShadow: 'none',
          border: `solid 2px ${grey ? Colors.silverSand : Colors.skobeloff}`
        }}
      >
        <Grid
          container
          direction="column"
          justifyContent="space-evenly"
          style={{ height: '100%' }}
        >
          <Grid container item justifyContent="center" textAlign="center">
            <Typography
              style={{
                fontSize: '18pt',
                fontWeight: 'bold',
                color: Colors.skobeloff
              }}
            >
              {title}
            </Typography>
          </Grid>
          <Grid container item justifyContent="center">
            <Typography
              style={{
                fontSize: '35pt',
                fontWeight: 'bold',
                color: Colors.richBlack
              }}
            >
              {value}
            </Typography>
          </Grid>
        </Grid>
      </Card>
    </Link>
  );
}
